import {Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import HeaderWithIcons from './HeaderWithIcons';

export default function About() {
	const {t} = useTranslation();
	return (<>
		<HeaderWithIcons title={t('about_us')}/>
		<div className="flex flex-col space-y-2 px-4">
			<Typography className="text-justify">{t('about_us_description')}</Typography>
		</div>
	</>);
}
